// assets
import mineAcsLogo from 'assets/images/mine-acs.png';

// ==============================|| LOGO - MINEACS ||============================== //

export default function LogoMain() {
  return <img src={mineAcsLogo} alt="MineACS" style={{ display: 'block', width: 160, height: 'auto', objectFit: 'contain' }} />;
}
